/* eslint-disable */
import sysConfig from '@/configs/sys';
import validator from '@/lib/json-validator';

const matlsApiUrl = sysConfig.matlsApiUrl;


validator
  .addSchema('/schools/getschoolsbykeywordandsystem', {
    type: 'object',
    properties: {
      // it's the name of school system, not id.
      // ex: 國中
      schoolsystem: {type: 'string'},
      term: {type: 'string'}
    },
    required: ['schoolsystem', 'term']
  });

export default {
  getSchools(params) {
    validator.validate('/schools/getschoolsbykeywordandsystem', params);

    return fetch
      .get(`${matlsApiUrl}/schools/getschoolsbykeywordandsystem`, {params})
      .then(res => res.json());
  }
};